import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Root, LeftIcon, RightIcon, Chevron } from './ListItem.styles';
var ListItem = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      children = _a.children,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon,
      submenu = _a.submenu,
      otherProps = __rest(_a, ["className", "disabled", "children", "leftIcon", "rightIcon", "submenu"]);

  var rootClassName = classnames(className, {
    disabled: disabled,
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    submenu: submenu
  });
  return _jsxs(Root, __assign({
    className: rootClassName,
    ref: ref
  }, otherProps, {
    children: [leftIcon && _jsx(LeftIcon, __assign({
      className: "ui-list-item__left-icon"
    }, {
      children: leftIcon
    })), children, rightIcon && _jsx(RightIcon, __assign({
      className: "ui-list-item__right-icon"
    }, {
      children: rightIcon
    })), submenu && _jsx(Chevron, {
      className: "ui-list-item__chevron",
      width: 20,
      height: 20
    })]
  }));
});
export default ListItem;